import ApiModel from 'base/api-model'

export default class Announcement extends ApiModel
  @prop 'uid', -> "announcement:#{@id}"

  @prop 'target_path', ->
    if @target_arn
      @target_arn.replace('place', 'park')
